<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="page.name"
    @change="$emit('input',false)"
  >
    <b-table
      responsive="lg"
      :fields="fields"
      :items="page.users"
    >
      <template #cell(action)="data">
        <b-button
          class="btn-icon"
          size="sm"
          variant="dark"
          @click="copyUserName(data)"
        >
          <FeatherIcon icon="CopyIcon" />
        </b-button>
      </template>
    </b-table>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="dark"
          @click="$emit('input',false)"
        >
          {{ $t('forms.ok') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BTable,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'

export default {
  name: 'PageOwners',
  components: {
    OkModal,
    BButton,
    BTable,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      fields: [],
      users: [],
    }
  },
  watch: {
    page(val) {
      this.users = val?.users ?? []
    },
  },
  mounted() {
    this.fields = [
      {
        key: 'action',
        label: this.$t('forms.actions'),
      },

      {
        key: 'last_login_at',
        label: this.$t('page.last_login_at'),
        sortable: true,
      },
      {
        key: 'slug',
        label: this.$t('fields.username'),
      },
      {
        key: 'name',
        label: this.$t('fields.name'),
      },
      {
        key: 'id',
        label: this.$t('fields.id'),
        formatter: value => `#${value}`,
      },

    ]
  },
  methods: {
    async copyUserName(data) {
      if (data.item?.slug) {
        await navigator.clipboard.writeText(data.item.slug)
        this.$notifySuccess(this.$t('general.copy-success'))
      }
    },
  },
}
</script>
